<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless">
    <div class="column is-12 pdh-30px pdb-0 hauteur-haut-affectation">
      <div class="level border-entete">
        <div class="level-left">
          <p class="has-text-link is-size-4 has-text-weight-bold">
            {{ $t('chargeTravailTech.ressourceAndAffectationInfo.titleAffectation') }}
          </p>
        </div>
        <div class="level-right is-cursor-pointer">
          <div @click="$emit('close')">
            <b-icon icon="close"
                    type="is-link"
                    size="is-small"
                    class="mgv-auto"></b-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless is-paddingless
    hauteur-affectation-information">
      <div class="pdh-30px pdb-20px">
        <div class="mgt-5px">
          <technicien-title
            @updateTechnicienSelect="selectTechnicien('otNonAffecte', null)"
            :is-icon-select="technicienSelect.technicienId === 'otNonAffecte'"
            :first-ligne="true"
            :display-logo="true"
            :technicien-information="{
            technicienId: null,
            technicien: $t('chargeTravailTech.ressourceAndAffectationInfo.otNonAffecte'),
            nbOts: nbOtSansTechnicien,
            }">
          </technicien-title>
        </div>
      </div>
      <div class="pdh-30px pdb-20px">
        <div class="mgt-5px">
          <technicien-title
            @updateTechnicienSelect="selectTechnicien('addTechnicien', null)"
            :technicien-information="{
          technicienId: null,
          technicien: $t('chargeTravailTech.actions.addTechnicien'),
          nbOts: null}"
            :isIconSelect="technicienSelect.technicienId === 'addTechnicien'"
            :displayLogo="false"
            :firstLigne="false">
          </technicien-title>
        </div>
      </div>
      <div v-for="(techInfo, index) in ressources" :key="index">
        <div class="pdh-30px pdb-20px">
          <technicien-title
            @updateTechnicienSelect="selectTechnicien(techInfo.technicienId, null)"
            :firstLigne="false"
            :isIconSelect="technicienSelect.technicienId === techInfo.technicienId"
            :displayLogo="true"
            :technicien-information="techInfo">
          </technicien-title>
          <informations-liste-a-date
            @updateTechnicienSelect="selectTechnicien"
            :technicien-id="techInfo.technicienId"
            :technicien-select="technicienSelect"
            :is-icon-select="technicienSelect.technicienId === techInfo.technicienId"
            :ressource-a-date="techInfo.dateList">
          </informations-liste-a-date>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-ressourceAffectation">
      <button @click="$emit('close')"
              class="button mgt-15px is-size-7 has-text-link">
        {{ $t('general.button.close') }}
      </button>
    </div>
  </div>
</template>

<script>

import technicienTitle
  from '@/components/logistique/chargeTravail/tech/affectation/technicienTitle';
import informationsListeADate
  from '@/components/logistique/chargeTravail/tech/affectation/informationsListeADate';

export default {
  props: {
    ressources: {
      required: true,
      type: Array,
    },
    nbOtSansTechnicien: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      technicienSelect: {
        technicienId: null,
        date: null,
      },
    };
  },
  components: {
    technicienTitle,
    informationsListeADate,
  },
  methods: {
    selectTechnicien(technicienId, date) {
      this.technicienSelect = {
        technicienId: technicienId,
        date: date,
      };
      this.$emit('openAffectationPopUp', this.technicienSelect);
    },
  },
};

</script>
